var __TEMP__ = require('./_baseForOwnRight.js');var baseForOwnRight = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_createBaseEach.js');var createBaseEach = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * The base implementation of `_.forEachRight` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEachRight = createBaseEach(baseForOwnRight, true);

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = baseEachRight;
